import React from 'react'

// styles
import { AboutUsStylesStylesContainer } from './styles/AboutUsStyles'

// images
import OwnerIconImg from 'assets/images/owner-icon.png'

export default function AboutUs(props) {
    // props
    const {
        currentRoute
    } = props

    return (
        <AboutUsStylesStylesContainer id="about-sec">
            <div className="container-fluid px-0">
                <div className="content col-12 col-lg-6 mx-auto">

                    {/* details */}
                    <div className="page-details">
                        <div className="container">
                            <div className="page-details-inner">
                                <p className="head-new st-fw-600 text-center mb-3">About Us</p>

                                <div className="main-sec d-flex flex-column-reverse flex-lg-row">
                                    <p className="desc1 st-fs-15 media-body mb-0">
                                        Krave Glass has been a popular brand in the industry since 2010. We are known for our high-end line of functional borosilicate glass pieces. All our pieces are designed with a combination of experienced scientific glass blowing techniques and functional glass art. We believe in making exceptionally cool, high quality pieces to add to your collection. All our pieces are carefully designed and made with love, innovation and positive energy. We're constantly designing new items and adding to our product line. We make a nice range of freezable handpipes, waterpipes and recyclers. Its our most popular collection to date. 
                                    </p>

                                    <div className="img-sec rounded-circle mb-2 mb-lg-0">
                                        <img src={OwnerIconImg} alt="" className="img-fluid rounded-circle" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </AboutUsStylesStylesContainer>
    )
}
